import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingScoringSummary } from './types/mailing-scoring-summary.type';

/**
 * Retrieves the scoring summary for a specific mailing by its ID.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing for which the scoring summary is to be fetched.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing a
 * {@link MailingScoringSummary} object.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getMailingScoringSummary = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingScoringSummary>>(
        formatString(Uri.mailing.getScoringSummary, mailingId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
